import apiService from './ApiService';
import RegionalService from './RegionalService';

const ProcesosService = {
  async getProcesos({ page = 1, pageSize = 10, idRegional = null } = {}) {
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('pageSize', pageSize);
    const regionalId = idRegional || RegionalService.getActiveRegionalId();
    if (regionalId) {
      params.set('idRegional', regionalId);
    }
    return apiService.get(`/procesos?${params.toString()}`);
  },

  async marcarLeido(id, { idRegional = null } = {}) {
    const regionalId = idRegional || RegionalService.getActiveRegionalId();
    const qs = regionalId ? `?idRegional=${encodeURIComponent(regionalId)}` : '';
    return apiService.put(`/procesos/${id}/leido${qs}`, {});
  },

  async detener(id, { idRegional = null } = {}) {
    const regionalId = idRegional || RegionalService.getActiveRegionalId();
    const qs = regionalId ? `?idRegional=${encodeURIComponent(regionalId)}` : '';
    return apiService.post(`/procesos/${id}/detener${qs}`, {});
  },

  async reintentar(id, { idRegional = null } = {}) {
    const regionalId = idRegional || RegionalService.getActiveRegionalId();
    const qs = regionalId ? `?idRegional=${encodeURIComponent(regionalId)}` : '';
    return apiService.post(`/procesos/${id}/reintentar${qs}`, {});
  }
};

export default ProcesosService;
